/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentPlanTransactionsResponseDataFromJSON, GetOrganizationPaymentPlanTransactionsResponseDataToJSON } from './GetOrganizationPaymentPlanTransactionsResponseData';
export function GetOrganizationPaymentPlanTransactionsResponseFromJSON(json) {
    return GetOrganizationPaymentPlanTransactionsResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentPlanTransactionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentPlanTransactionsResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentPlanTransactionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentPlanTransactionsResponseDataToJSON(value.data)
    };
}
